<div class="edit-settings-root">
  <app-header>{{labels.changeSystemLanguage}}</app-header>
  <div class="radio-button">
    <input type="radio"
           id="english-language"
           name="system-language"
           value="en"
           [formControl]="languageControl">
    <label for="english-language">{{labels.english}}</label>
  </div>
  <div class="radio-button">
    <input type="radio"
           id="portuguese-language"
           name="system-language"
           value="pt"
           [formControl]="languageControl">
    <label for="portuguese-language">{{labels.portuguese}}</label>
  </div>
  <div class="radio-button">
    <input type="radio"
           id="spanish-language"
           name="system-language"
           value="es"
           [formControl]="languageControl">
    <label for="spanish-language">{{labels.spanish}}</label>
  </div>
  <app-primary-button (clickAction)="saveSettingsChanges()" [disabled]="isFormDisabled() || loading">{{labels.saveSettingsChanges}}</app-primary-button>
</div>
